export default __webpack_public_path__ + "static/media/theracer-small.51874213.png";